import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import useNotificationsInbox from "../useNotificationsInbox";
import useUnreadNotifications from "../useUnreadNotifications";
import NotificationsPanel, { NotificationsSummary } from "./NotificationsPanel";
import { NOTIFICATIONS_COPY } from "../notificationsCopy";

import "../styles.css";

const NotificationsPopover = ({ variant = "count", align = "right" }) => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const holder = useRef(null);

  const { count, label, hasUnread } = useUnreadNotifications();

  const close = useCallback(() => setOpen(false), []);

  const inbox = useNotificationsInbox({ enabled: open, onNavigate: close });

  useEffect(() => {
    close();
  }, [pathname, close]);

  useEffect(() => {
    if (!open) return undefined;

    const onPointerDown = (event) => {
      if (!holder.current?.contains(event.target)) close();
    };

    const onKeyDown = (event) => {
      if (event.key === "Escape") close();
    };

    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open, close]);

  return (
    <div className="nt-bell-holder" ref={holder}>
      <button
        type="button"
        className={`nt-bell${open ? " is-active" : ""}`}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label={count ? `Notifications, ${label} unread` : "Notifications"}
        onClick={() => setOpen((previous) => !previous)}
      >
        <img
          src={
            open
              ? "/assets/icons/notification-active.svg"
              : "/assets/icons/topbar/notification.svg"
          }
          alt=""
          width={24}
          height={24}
        />

        {hasUnread &&
          (variant === "dot" ? (
            <span className="nt-bell-dot" />
          ) : (
            <span className="nt-bell-badge">{label}</span>
          ))}
      </button>

      {open && (
        <div
          className={`nt-popover nt-popover--${align}`}
          role="dialog"
          aria-label={NOTIFICATIONS_COPY.pageTitle}
        >
          <header className="nt-popover-head">
            <h2>{NOTIFICATIONS_COPY.pageTitle}</h2>

            <button
              type="button"
              className="nt-refresh"
              onClick={inbox.refresh}
              disabled={inbox.refreshing}
            >
              {NOTIFICATIONS_COPY.refresh}
            </button>
          </header>

          <NotificationsSummary inbox={inbox} />

          <div className="nt-popover-scroll">
            <NotificationsPanel inbox={inbox} skeletonRows={4} />
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationsPopover;
